/**
 * @generated SignedSource<<6520f1ec0ebd44d3fb57c50968d560c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NoteSelectWorkspace_piece$data = {
  readonly id: string;
  readonly sheets: ReadonlyArray<{
    readonly id: string;
    readonly note_combine_steps: ReadonlyArray<{
      readonly id: string;
      readonly status: MusicParseStatus;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPage_sheet">;
  }>;
  readonly " $fragmentType": "NoteSelectWorkspace_piece";
};
export type NoteSelectWorkspace_piece$key = {
  readonly " $data"?: NoteSelectWorkspace_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteSelectWorkspace_piece">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteSelectWorkspace_piece",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "note_combine_steps",
          "args": [
            {
              "kind": "Literal",
              "name": "step_type",
              "value": "NOTE_DATA_SOURCE_COMBINE"
            }
          ],
          "concreteType": "MusicParseStep",
          "kind": "LinkedField",
          "name": "steps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": "steps(step_type:\"NOTE_DATA_SOURCE_COMBINE\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteFinderPage_sheet"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};
})();

(node as any).hash = "2e62374cef5a9adac70454ecb05163e6";

export default node;
